import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export class AppConfig {
  public readonly production: boolean;
  public readonly local: boolean;
  public readonly name: string;
  public readonly baseUri: string;
  public readonly googleClientId: string;
  public readonly facebookClientId: string;
  public readonly transClientId: string;
  public readonly transUrl: string;
  public readonly sentry: string;
}
const $APP_CONFIG = new BehaviorSubject<AppConfig>(new AppConfig());

export function APP_CONFIG(): Observable<AppConfig> {
  return $APP_CONFIG.asObservable();
}

@Injectable()
export class AppConfigService {
  constructor(private http: HttpClient) {}

  public load() {
    return new Promise((resolve, reject) => {
      const confName = environment.name + '.json';
      this.http
        .get('/config/' + confName)
        .pipe(
          map((res) => res),
          catchError((): any => {
            reject(true);
            return throwError(new Error('Couldnt find config file'));
          }),
        )
        .subscribe((envResponse: any) => {
          const config = new AppConfig();
          if ((environment.name === 'localtest')) {
            envResponse.baseUri = environment.baseUri;
          }
          $APP_CONFIG.next(Object.assign(config, envResponse));
          resolve(true);
        });
    });
  }
}
